import angular from 'angular';
import _ from 'lodash';
import SubEntity from "../data/seller/sub-entity.data";


(function() {
    'use strict';
    angular.module('app.core').factory('linkRequestDA', linkRequestDA);

    linkRequestDA.$inject = ['Restangular',  'CONF' , '$http','LinkRequest','$q' ,'DateService'];

    /* @ngInject */
    function linkRequestDA(Restangular, CONF ,$http,LinkRequest,$q,DateService) {
        var version = 'v1';
        var baseUrl = 'link-request';
        var FileSaver = require('file-saver');



        var exports = {
            getLinkRequestCount: getLinkRequestCount,
            getLinkRequestList: getLinkRequestList,
            getLinkRequestExport:getLinkRequestExport,
            searchSubEntitiesByNameOrCode:searchSubEntitiesByNameOrCode,
        };

        return exports;

        ////////////////


        function getLinkRequestCount(invitedBuyerId, sens) {
            var url =
            CONF.apiContext +
            CONF.apiBaseUrl +
            '/' +
            version +
            '/' +
            baseUrl +
            '/' +
            invitedBuyerId+
            '/'+
            sens +
            '/' +
            'link-request-count';
        return $http.get(url).then(function(data){
            return data.data ;
        });
        }

        /**
         * Récupere les connexion d'une invitedEntity buyer
         */
        function getLinkRequestList(invitedEntityId,sens, invitedBuyerLinkRequestFilter) {

            return Restangular.oneUrl(CONF.apiBaseUrl)
                .oneUrl(version)
                .one(baseUrl, invitedEntityId)
                .one(sens)
                .all('search-link-request')
                .post(invitedBuyerLinkRequestFilter)
                .then(function (linkRequests) {
                    return _.map(linkRequests, function (r) {
                        return new LinkRequest(r);
                    });
                });
        }

        /**
         * Récupere les connexion d'une invitedEntity buyer
         */
        function searchSubEntitiesByNameOrCode(searchValue) {
            return Restangular.oneUrl(CONF.apiBaseUrl)
                .oneUrl(version)
                .one('legal-entity/sub-entity')
                .all('search-sub-entities')
                .post({ value: searchValue })
                .then(function (pageSubEntities) {
                    return _.map(pageSubEntities.content, function (s) {
                        return new SubEntity(s);
                    });
                });
        }

        function getLinkRequestExport(invitedBuyerLinkRequestFilter, format, invitedBuyerId, sens) {
            var deferred = $q.defer();
            $http.post(CONF.apiContext + CONF.apiBaseUrl + '/' + version + '/'
                + baseUrl + '/' + invitedBuyerId + '/' + sens + '/export' + '/'
                + format, invitedBuyerLinkRequestFilter,
                {responseType: "blob"}).then(function (data) {
                var now = new Date();
                var filename = format === "CSV" ? 'EXPORT-LIST-CONNECTIONREQUESTS-' + DateService.formatAsYMD_HM(now) + '.csv' : 'EXPORT-LIST-CONNECTIONREQUESTS-' + DateService.formatAsYMD_HM(now) + '.xlsx';

                FileSaver.saveAs(data.data, filename);
                deferred.resolve(filename);

            }, function (data) {
                var e = /* error */
                    deferred.reject(e, data);
            });
            return deferred.promise;

        }
    }
})();
